import cn from 'classnames';
import Markdown from 'markdown-to-jsx';
import React, { useEffect, useState } from 'react';
import { DropDownContentType } from 'src/modules/parkplusStoreV2/types/product';
import { Typography } from 'ui-v2/components/Typography';
import s from './Dropdown.module.scss';
import Icon from 'ui-v2/components/Icon/Icon';

interface DropdownProps {
  label: string;
  content: any;
  data: any;
  isOpen?: boolean;
  contentType?: string;
  handleOpenCount?: (operation: string) => void;
}

export const Dropdown: React.FunctionComponent<DropdownProps> = ({
  label,
  content,
  data,
  isOpen = false,
  contentType = DropDownContentType.TEXT,
  handleOpenCount,
}) => {
  const [open, setOpen] = useState<boolean>(isOpen);
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);
  return (
    <div className={s.expandable}>
      <div
        className={s.heading}
        onClick={() => {
          if (open) {
            setOpen(false);
            handleOpenCount('DECREASE');
          } else {
            setOpen(true);
            handleOpenCount('INCREASE');
          }
        }}
        aria-hidden
      >
        <Typography label={label} variant="body_3_regular" />
        {open ? (
          <Icon name="ChevronUpRegular" color="tertiary" width={20} height={20} />
        ) : (
          <Icon name="ChevronDownRegular" color="tertiary" width={20} height={20} />
        )}
      </div>

      <div className={cn(s.content, { [s.openCard]: open })}>
        {contentType === DropDownContentType.TABLE ? (
          <div className={s.table_wrapper}>
            <table className={s.productDetails}>
              {data?.map((item, index: number) => (
                <tr
                  className={s.row}
                  style={
                    index !== data.length - 1
                      ? { borderBottom: '1px solid #DEDEDE' }
                      : {}
                  }
                  key={`${item?.label}_${item?.value}`}
                >
                  <td
                    className={s.label}
                    style={{
                      width: 'calc( 45vh - 16px )',
                      paddingRight: '5px',
                    }}
                  >
                    <Typography
                      label={item?.label}
                      variant="body_3_regular"
                      color="secondary"
                    />
                  </td>
                  <td
                    className={s.value}
                    style={{ width: 'calc( 55vh - 16px )' }}
                  >
                    <Typography
                      label={item?.value}
                      variant="body_3_regular"
                      color="secondary"
                    />
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          <div className={s.list_data}>
            <Markdown>{content}</Markdown>
          </div>
        )}
      </div>
    </div>
  );
};
